import { Bell } from 'lucide-react';
import { ANDROID_APP_URL, IOS_APP_URL } from '@/constants/config';
import { Button, StoreBadge } from '@/components/ui';
import { useCatalogPath } from '@/hooks/useRouteLocale';

/**
 * Follow call to action on the sale pages. Following is per brand (there is
 * no "follow an event"), so it sends people to the brands and the app, which
 * notifies followers. The wording is the app banner's existing line.
 */
export function SaleFollowCta() {
  // `/pk/en/brands` once the URL move is live (web plan W2.1).
  const catalog = useCatalogPath();
  return (
    <section
      aria-labelledby="sale-follow-heading"
      className="flex flex-col gap-4 rounded-2xl border border-card-border bg-card p-5 md:flex-row md:items-center md:justify-between"
    >
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
          <Bell size={20} className="text-primary" aria-hidden="true" />
        </span>
        <div>
          <h2 id="sale-follow-heading" className="text-lg font-extrabold tracking-tight text-ink">
            Follow brands
          </h2>
          <p className="mt-1 text-sm text-ink-secondary">Follow brands and get notified when a deal drops.</p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Button to={catalog('/brands')} size="sm">
          Browse brands
        </Button>
        {IOS_APP_URL && <StoreBadge store="app-store" href={IOS_APP_URL} />}
        <StoreBadge store="google-play" href={ANDROID_APP_URL} />
      </div>
    </section>
  );
}

export default SaleFollowCta;
